// deriveMode — picks the ProjectsV2 render mode ('datacenter' | 'hydrogen')
// from the fetched project list, falling back to the org's configured
// default when no majority exists.
//
// Rules:
//   - Empty list        → orgDefault (so a brand-new org lands in the right
//                         view before saving anything).
//   - Majority wins     → 'hydrogen' or 'datacenter' from use_case plurality.
//   - Tie               → orgDefault.
//
// `orgDefault` is read from org.branding.default_use_case on the server;
// callers that don't know it (tests, legacy call sites) pass undefined and
// get the historical 'datacenter' baseline.

const VALID = new Set(['hydrogen', 'datacenter']);

export function deriveMode(projects, orgDefault) {
  const fallback = VALID.has(orgDefault) ? orgDefault : 'datacenter';
  if (!Array.isArray(projects) || projects.length === 0) return fallback;

  let hydrogen = 0;
  let datacenter = 0;
  for (const p of projects) {
    if (p?.use_case === 'hydrogen') hydrogen += 1;
    else datacenter += 1;
  }
  if (hydrogen === datacenter) return fallback;
  return hydrogen > datacenter ? 'hydrogen' : 'datacenter';
}
